import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { CouriersService } from '../../../../services/courier-services/couriers.service';
import { CourierServiceModel, PackageOption } from '../../../../models/inModels/MarketPlaceModel';

@Component({
  selector: 'app-create-courier',
  templateUrl: './create-courier.component.html',
})
export class CreateCourierComponent implements OnInit {
  model: CourierServiceModel;
  loading = false;
  error: Message[];
  messages: Message[];
  items: PackageOption[] = [];
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: CouriersService,) {
  }

  ngOnInit() {
    this.model = new CourierServiceModel();
    this.model.Enabled = true;
  }

  goBack(): void {
    this.router.navigate(['/marketplace/courier-services']);
  }

  save() {
    this.loading = true;
    this.service.create(this.model).then(
      res => {
        this.model = new CourierServiceModel(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  handleBackgroundImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.LogoId = result.PublicId;
    this.loading = false;
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/courier-services/edit/create-courier/create-courier.component.ts